import { useState, useEffect } from 'react';
import ModalDialog from '../ModalDialog/ModalDialog';
import { GoogleLogin, googleLogout } from '@react-oauth/google';
import jwt_decode from 'jwt-decode';
import './style.css';
import UserIcon from './userFace.svg';
import { User } from '../../interface/User';

export interface ISignInProps {}

interface GoogleCredentials {
  name: string;
  email: string;
  picture: string;
  email_verified: boolean;
  iss: string;
}

const SignIn: React.FunctionComponent<ISignInProps> = (props) => {
  // https://www.geeksforgeeks.org/link-and-navlink-components-in-react-router-dom/
  // https://rozetka.com.ua/ua/
  // https://www.freecodecamp.org/news/how-to-use-localstorage-with-react-hooks-to-set-and-get-items/

  const [openModal, setOpenModal] = useState(false);

  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      let userStorage = localStorage.getItem('user');
      if (userStorage) {
        setUser(JSON.parse(userStorage));
      }
    }
  }, [user]);

  const googleLoginButton = (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <GoogleLogin
          locale="uk_UA"
          shape="circle"
          onSuccess={(credentialResponse) => {
            let credentials = jwt_decode<GoogleCredentials>(credentialResponse.credential || '');
            let user: User = {
              name: credentials.name,
              email: credentials.email,
              picture: credentials.picture,
              emailVerified: credentials.email_verified,
              iss: credentials.iss
            };
            setUser(user);
            setOpenModal(false);
          }}
          onError={() => {
            console.log('Login Failed');
          }}
        />
      </div>
    </>
  );

  const googleLogoutButton = (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <button
          onClick={() => {
            localStorage.setItem('a', '1');
            window.location.reload();
          }}
        >
          Адмін панель
        </button>
        <button
          onClick={() => {
            googleLogout();
            localStorage.removeItem('user');
            setUser(user);
            setOpenModal(false);
          }}
          title="Вихід"
        >
          Вихід
        </button>
      </div>
    </>
  );

  return (
    <>
      <img onClick={() => setOpenModal(!openModal)} alt="signIn" title="Увійти як користувач" className={'signInIcon'} src={UserIcon} />
      <ModalDialog
        title={user == null ? 'Увійти як користувач' : `Користувач ${user.name}`}
        openModal={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        content={user == null ? googleLoginButton : googleLogoutButton}
      />
    </>
  );
};

export default SignIn;
